// components/common/LabelValue.js
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from 'views/ConstantColors';

export const LabelValue = ({ label, value, icon: Icon, chip = false }) => (
    <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {Icon && <Icon fontSize="small" />}
                {label}
            </Box>
        </Typography>
        {chip ? (
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    bgcolor: theme.primary.light,
                    color: theme.primary.main,
                    px: 2,
                    py: 0.5,
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500
                }}
            >
                {value || '-'}
            </Box>
        ) : (
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {value || '-'}
            </Typography>
        )}
    </Box>
);

LabelValue.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.elementType,
    chip: PropTypes.bool
};

LabelValue.defaultProps = {
    icon: null,
    chip: false,
    value: '-'
};
